import { useAdminSettings } from "@/hooks/useAdminSettings";
import type { Plan } from "@/interfaces/interfaces";
import { formatDate } from "@/utils/date.utils";
import { getCommittee } from "@/utils/utils";
import { Separator } from "../ui/separator";
import { TableCell, TableRow } from "../ui/table";
import { ConflictBadge } from "./ConflictBadge";
import { StatusBadge } from "./StatusBadge";
import { PlanChangeNameButton } from "./planChangeNameButton";
import { PlanDeleteButton } from "./planDeleteButton";
import { PlanTogglePublicButton } from "./planTogglePublicButton";

interface UserPlansListRowProps {
  plan: Plan;
  collisions: { room: number; inventory: number };
  onPlanClick: (plan: Plan) => void;
}

export const UserPlansListRow = ({
  plan,
  collisions,
  onPlanClick,
}: UserPlansListRowProps) => {
  const { isPlanEditLocked } = useAdminSettings();
  const updatedAt = formatDate(plan.updatedAt, "full");
  const committee = getCommittee(plan.committeeId);

  const status = isPlanEditLocked ? "locked" : plan.public ? "public" : "draft";

  return (
    <TableRow key={plan.id}>
      <TableCell
        className="hover:cursor-pointer hover:underline"
        onClick={() => onPlanClick(plan)}
      >
        <div className="flex items-center gap-2">
          {committee && (
            <span
              className="w-2 h-2 shrink-0"
              style={{ backgroundColor: committee.color }}
            />
          )}
          <span className="font-medium">{plan.label}</span>
        </div>
      </TableCell>
      <TableCell className="hidden sm:table-cell">
        {plan.events.length}
      </TableCell>
      <TableCell className="hidden sm:table-cell">
        <StatusBadge status={status} />
      </TableCell>
      <TableCell className="hidden sm:table-cell">
        <ConflictBadge numConflicts={collisions.room + collisions.inventory} />
      </TableCell>
      <TableCell className="hidden md:table-cell text-muted-foreground text-sm">
        {updatedAt}
      </TableCell>
      <TableCell className="flex items-center justify-end sm:gap-2">
        <PlanDeleteButton plan={plan} />
        <Separator orientation="vertical" className="h-5 hidden sm:block" />
        <PlanChangeNameButton plan={plan} />
        <PlanTogglePublicButton plan={plan} />
      </TableCell>
    </TableRow>
  );
};
